import type { WeaponKind } from "@stormglass/game-core";

export function WeatherIcon({
  kind,
  label = true,
}: {
  readonly kind: WeaponKind;
  readonly label?: boolean;
}): React.JSX.Element {
  return (
    <span
      className={`weather-icon weather-icon--${kind}`}
      aria-label={label ? kind : undefined}
      aria-hidden={!label}
    >
      <span className="weather-icon__mark" />
    </span>
  );
}
